import { useContext } from 'react';

import { TimeframeContext } from './context';

export const useWeekDate = () => {
  const { weekDate } = useContext(TimeframeContext);
  return weekDate;
};
